module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Settings-1-d590c580770aa41cd19411d9f6067455.svg";